module.exports = __webpack_public_path__ + "img/verticalIco6.ff0eea19.png";